import { useState } from "react";

const faqs = [
  {
    q: "Who can partner with Harambee Global Ventures?",
    a: "We welcome partnerships from a wide range of organizations &mdash; including development finance institutions, public-private partnership stakeholders, local family offices, diaspora networks, educational and workforce development organizations, community groups, strategic advisory firms, and mission-aligned ventures. If your organization shares our commitment to education, opportunity, and long-term wealth creation for the African Diaspora, we want to hear from you.",
  },
  {
    q: "Are partnerships only financial in nature?",
    a: "Not at all. While some partnerships may involve financial collaboration, the majority of our partnerships are focused on education, outreach, programming, and community engagement. We are equally interested in co-hosting workshops, developing educational content, supporting investor-readiness programs, and building long-term ecosystem relationships. Financial arrangements, where relevant, are always structured transparently and in full compliance with applicable standards.",
  },
  {
    q: "Do you work with both institutions and community organizations?",
    a: "Yes. We actively seek partnerships across the full spectrum &mdash; from large development finance institutions and family offices to grassroots community organizations and diaspora associations. We believe that meaningful impact requires collaboration at every level, and we tailor our partnership approach to suit the size, capacity, and goals of each partner.",
  },
  {
    q: "Can diaspora groups and associations collaborate with Harambee?",
    a: "Absolutely. Diaspora groups, associations, and community networks are among our most valued potential partners. We are specifically built to serve the African Diaspora, and we see diaspora organizations as essential collaborators in expanding access to education, advisory support, and long-term opportunity. We welcome conversations with diaspora groups of all sizes and structures.",
  },
  {
    q: "How do we begin a partnership discussion?",
    a: "Starting a conversation is simple. Complete the partnership inquiry form on this page, and our team will review your submission and reach out within 2&ndash;3 business days to schedule an initial conversation. There is no commitment required at this stage &mdash; we simply want to understand your organization, your goals, and whether there is a meaningful opportunity to collaborate.",
  },
];

export default function PartnershipsFAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-5 gap-14">
        {/* Left */}
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            FAQ
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
            Have a question that isn&apos;t answered here? We are happy to help. Reach out directly and our team will respond promptly.
          </p>
          <a
            href="#partner-form"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-[#1A4D3C] text-white text-sm font-medium hover:bg-[#0D2E1E] transition-colors whitespace-nowrap cursor-pointer"
          >
            Ask Us Directly <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* Right - Accordion */}
        <div className="lg:col-span-3 space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white border border-[#E8E4DC] rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer group"
              >
                <span className="font-medium text-[#2B2D2F] text-sm pr-4 group-hover:text-[#1A4D3C] transition-colors">
                  {faq.q}
                </span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#F8F6F3] flex-shrink-0">
                  <i
                    className={`text-[#1A4D3C] text-base transition-transform duration-300 ${
                      open === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </div>
              </button>
              {open === i && (
                <div className="px-7 pb-6">
                  <p
                    className="text-[#6B6B6B] text-sm leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: faq.a }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
